query AutomationGraphIssues($id: ID!, $input: AutomationInput!) {
  automationGraphIssues(id: $id, input: $input) {
    nodeId
    code
    exitRuleId
  }
}
